/* eslint-disable react-hooks/rules-of-hooks */
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IState } from '../../../../store';
import { pathOr } from 'ramda';
import { Thumbnail } from './Thumbnail';
import { trackTourCards } from './analytics/trackTourCards';
import { IconPlan } from './Icons/IconPlan';
import { showGalleryElement } from '../../../../store/gallery';
import { IPhotoSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { photosSelector } from './selectors/photosSelector';

export const planThumbnailSelector = (state: IState): string | null => {
  return pathOr(null, ['offerData', 'tourV2', 'plan', 'thumbnail'], state);
};

export const selectFirstLayoutSlide = (state: IState) => {
  const media = photosSelector(state);

  const firstLayoutSlideIndex = media.findIndex((p: IPhotoSchema) => Boolean(p.isLayout));

  return firstLayoutSlideIndex >= 0 ? firstLayoutSlideIndex : undefined;
};

export const PlanThumbnailContainer = () => {
  const dispatch = useDispatch();
  const planThumbnail = useSelector(planThumbnailSelector);
  const firstLayoutSlide = useSelector(selectFirstLayoutSlide);

  if (!planThumbnail || firstLayoutSlide === undefined) {
    return null;
  }

  const planHandler = React.useCallback(() => {
    trackTourCards('plan_photo_block');
    dispatch(showGalleryElement(firstLayoutSlide || 0));
  }, []);

  return <Thumbnail onClick={planHandler} img={planThumbnail} text="Планировка" icon={<IconPlan />} />;
};

PlanThumbnailContainer.displayName = 'PlanThumbnailContainer';
